export class AddRightToEmitter {
  /**
   *
   */
  eId: number;

  /**
   *
   */
  gpId: number;

  /**
   *
   */
  rId: number;

  /**
   *Creates an instance of AddRightToEmitter.
   *
   * @param emitterId the emiter id
   * @param groupId the group id
   * @param rightId the right id
   */
  constructor(emitterId: number, groupId: number, rightId: number) {
    this.eId = emitterId;
    this.gpId = groupId;
    this.rId = rightId;
  }
}
